import { useEffect, useState } from 'react';
import Script from 'next/script';
import getRuntimeConfig from '~/services/runtime-config.service';

export default function Recaptcha() {
    const [siteKey, setSiteKey] = useState<string>('');

    useEffect(() => {
        const loadConfig = async () => {
            const config = await getRuntimeConfig();
            setSiteKey(config.nextPublicRecaptchaEnterpriseSiteKey as string);
        };

        loadConfig();
    }, []);

    if (!siteKey) return null;

    return (
        <Script
            id="recaptcha-enterprise"
            src={`https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`}
            strategy="afterInteractive"
            onReady={() => {
                console.log('reCAPTCHA Enterprise loaded');
            }}
        />
    );
}
